<template>
    <div>

        <button @click="requestDevice">连接USB设备</button>
        <button @click="sendData" :disabled="!device">发送数据</button>
        <button @click="disconnect" :disabled="!device">断开连接</button>

        <div v-if="device">已连接: {{ device.productName }}</div>
        <div>接收数据: {{ receivedData }}</div>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'BlueTooth', // 组件名称
    components: {

    },
    watch: {
    },
    computed: {
        ...mapGetters(['getTranslation']),
    },
    data() {
        return {
            device: null,
            receivedData: '',
            isConnected: false
        }
    },
    mounted() {
        if (!navigator.usb) {
            console.error('浏览器不支持WebUSB API');
            alert('请使用Chrome/Edge 61+浏览器');
        }

    },
    created() {
        this.init();
    },
    methods: {
        init() {

        },
        async requestDevice() {
            try {
                // 可以添加过滤条件
                const filters = [
                    
                ];

                this.device = await navigator.usb.requestDevice({ filters });
                await this.openDevice();
                this.isConnected = true;

                this.$message.success('设备连接成功');
            } catch (error) {
                console.error('连接失败:', error);
                this.$message.error('连接失败: ' + error.message);
            }
        },

        // 打开设备
        async openDevice() {
            await this.device.open();

            // 选择配置
            await this.device.selectConfiguration(1);

            // 声明接口
            await this.device.claimInterface(0);

            // 开始接收数据
            this.receiveData();
        },

        // 发送数据
        async sendData() {
            if (!this.device) return;

            try {
                const data = new Uint8Array([0x01, 0x02, 0x03]); // 示例数据

                await this.device.transferOut(1, data); // endpoint 1
                console.log('数据发送成功');
            } catch (error) {
                console.error('发送失败:', error);
            }
        },

        // 接收数据
        async receiveData() {
            if (!this.device) return;

            try {
                const result = await this.device.transferIn(2, 64); // endpoint 2, 64字节

                if (result.data && result.data.buffer) {
                    const data = new Uint8Array(result.data.buffer);
                    this.receivedData = Array.from(data).map(b => b.toString(16)).join(' ');

                    // 继续接收
                    this.receiveData();
                }
            } catch (error) {
                console.error('接收失败:', error);
            }
        },

        // 断开连接
        async disconnect() {
            if (this.device) {
                await this.device.close();
                this.device = null;
                this.isConnected = false;
                this.$message.info('设备已断开');
            }
        },

        // 获取已连接的设备
        async getConnectedDevices() {
            const devices = await navigator.usb.getDevices();
            console.log('已连接设备:', devices);
            return devices;
        }

    },
}
</script>
<style></style>
<style scoped>
@import url('../../assets/style/list.css');
</style>
